import { css } from 'emotion'

export const EllipsisVertialIconStyles = css`
  transform: rotate(90deg);
`
